import { supabase } from '../supabase';

const channelCache = new Map<string, ReturnType<typeof supabase.channel>>();

export const sendBroadcast = (channelName: string, event: string, payload: any) => {
  let channel = channelCache.get(channelName);
  if (!channel) {
    channel = supabase.channel(channelName);
    channel.subscribe();
    channelCache.set(channelName, channel);
  }
  channel.send({
    type: 'broadcast',
    event: event,
    payload: payload
  }).catch((err) => {
    console.warn(`[Broadcast] Failed to send on ${channelName}:`, err);
  });
};
